var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
var useStyles = createStyles(function (_ref) {
  var css = _ref.css,
    prefixCls = _ref.prefixCls;
  return {
    tabslWrap: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      .", "-tabs-tab-icon {\n        margin-right: 8px !important;\n        margin-inline-end: 8px !important;\n      }\n    "])), prefixCls)
  };
});
export default useStyles;